/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bar_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bar Chart Maker (Free, Online) — Toolverse`)
};

const es_bar_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creador de Gráficos de Barras (Gratis, Online) — Toolverse`)
};

const de_bar_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balkendiagramm-Ersteller (Kostenlos, Online) — Toolverse`)
};

const nl_bar_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Staafdiagrammaker (gratis, online) — Toolverse`)
};

const fr_bar_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créateur de graphique à barres (gratuit, en ligne) — Toolverse`)
};

const it_bar_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creatore di grafici a barre (gratuito, online) — Toolverse`)
};

const pt_br2_bar_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador de Gráfico de Barras (Grátis, Online) — Toolverse`)
};

const pt_bar_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criador de Gráficos de Barras (Grátis, Online) — Toolverse`)
};

const ja_bar_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`棒グラフ作成ツール（無料・オンライン） — Toolverse`)
};

const zh_bar_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`柱状图制作工具（免费在线）— Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bar_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bar_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bar_meta_title", locale)
	if (locale === "en") return en_bar_meta_title(inputs)
	if (locale === "es") return es_bar_meta_title(inputs)
	if (locale === "de") return de_bar_meta_title(inputs)
	if (locale === "nl") return nl_bar_meta_title(inputs)
	if (locale === "fr") return fr_bar_meta_title(inputs)
	if (locale === "it") return it_bar_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_bar_meta_title(inputs)
	if (locale === "pt") return pt_bar_meta_title(inputs)
	if (locale === "ja") return ja_bar_meta_title(inputs)
	return zh_bar_meta_title(inputs)
};